/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ people: NonNullable<unknown>, opens: NonNullable<unknown>, scans: NonNullable<unknown> }} Geocelltooltip2Inputs */

const en_geocelltooltip2 = /** @type {(inputs: Geocelltooltip2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.people} people · ${i?.opens} opens · ${i?.scans} scans`)
};

const de_geocelltooltip2 = /** @type {(inputs: Geocelltooltip2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.people} Personen · ${i?.opens} Öffnungen · ${i?.scans} Scans`)
};

/**
* | output |
* | --- |
* | "{people} people · {opens} opens · {scans} scans" |
*
* @param {Geocelltooltip2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geocelltooltip2 = /** @type {((inputs: Geocelltooltip2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geocelltooltip2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geocelltooltip2(inputs)
	return de_geocelltooltip2(inputs)
});
export { geocelltooltip2 as "geoCellTooltip" }